<template>
    <div v-if="translations.length < 1" class="list-group-item">
      <span class="badge text-bg-warning">{{ locale.locale }}</span>
      <span class="px-2 py-1 rounded small text-muted font-italic creatable" @click="addTranslation" v-tooltip="$t('js.tooltips.translation.create_new_under_scope', {scope: $t(`js.backend.translations.scopes.${scope.type}`)})">
        {{ $t('js.backend.translations.no_translations') }}
      </span>

    </div>
    <div v-else class="list-group-item d-flex justify-content-between">
      <div class="hstack w-100">
        <span class="badge text-bg-secondary me-2">{{ locale.locale }}</span>
        <template v-for="translation in translations">
          <Translation v-if="translation === visibleTranslation"
                       :previousTranslation="translation"
                       :key="`${translation.scope_type}_${locale.locale}_${translation.updated_at}`"
                       :scope="scope"
                       :tkey="translation_key.key"
                       :tightScopeExist="hasTranslationInCurrentScope"
                       @addTranslation="addTranslation"
                       @removeTranslation="removeTranslation"
                       @changeTranslation="changeTranslation"
          />
        </template>
      </div>
      <div>
        <div class="dropdown show" v-if="persistedTranslations.length > 1">
          <button v-if="visibleTranslation" class="btn badge btn-dark dropdown-toggle ms-2" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i v-if="visibleTranslation === persistedTranslations[persistedTranslations.length -1]" class="fas fa-eye me-1"></i>
            {{visibleTranslation.scope_type ? $t(`js.backend.translations.scopes.${visibleTranslation.scope_type}`) : $t('js.backend.translations.scopes.default') }}
          </button>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <button class="dropdown-item" type="button" v-for="(translation, index) in persistedTranslations.filter(t => t.updated_at)" @click.prevent="changeVisibleTranslation(index)" :key="translation.scope_type">
              {{ translation.scope_type ? $t(`js.backend.translations.scopes.${translation.scope_type}`) : $t('js.backend.translations.scopes.default')  }}
            </button>
          </div>
        </div>
        <div v-else class="badge text-bg-dark ms-2">
          <i class="fas fa-eye me-1"></i>
          {{ visibleTranslation.scope_type ? $t(`js.backend.translations.scopes.${visibleTranslation.scope_type}`) : $t('js.backend.translations.scopes.default')  }}
        </div>
      </div>
    </div>
</template>

<script>
    import Translation from "./Translation.vue"
    export default {
        name: "TranslationGroup",
      components: {Translation},
      props: {
        initialTranslations: Array,
        locale: Object,
        scope: Object,
        translation_key: Object
      },
      data({ initialTranslations }){
        return {
          visibleIndex: initialTranslations.length-1,
          translations: [...initialTranslations]
        }
      },
      computed: {
        visibleTranslation(){
          return this.translations[this.visibleIndex]
        },
        hasTranslationInCurrentScope(){
          let tightestScope = this.translations[this.translations.length-1].scope_type
          return tightestScope === this.scope.type
        },
        persistedTranslations(){
          return this.translations.filter(t => t.updated_at)
        }
      },
      methods: {
        changeVisibleTranslation(index){
          this.visibleIndex = index
        },
        addTranslation(base_translation = null){
          if(!this.translations.some(t => t.scope_type === this.scope.type)){
            this.translations.push({
              id: null,
              translation_key_id: this.translation_key.id,
              locale_id: this.locale.id,
              scope_type: this.scope.type,
              scope_id: this.scope.id,
              default_text: base_translation ? base_translation.default_text : null,
              translated_text: base_translation ? base_translation.translated_text : null,
              created_at: null,
              updated_at: null
            })
          }
          this.visibleIndex = this.translations.length-1
        },
        removeTranslation(translation){
          let index = this.translations.indexOf(translation)
          this.translations.splice(index, 1)
          this.visibleIndex = this.translations.length-1
        },
        changeTranslation(from, to){
          this.translations.splice(this.translations.indexOf(from), 1, to)
        },
      }
    }
</script>